import { getNumericArrayFromTo } from './products.service';

export const formatQuantityNumericOptions = (from, to) =>
  getNumericArrayFromTo(from, to).map((number) => ({
    label: number.toString(),
    value: number.toString(),
    id: `quantity_is_${number}`,
    key: `quantity is ${number}`,
  }));

/**
 * @description formats and returns the string with '(s)' or plural form
 * @param room {string}
 * @returns {string}
 */
export const formatRoomsPlural = (room) => {
  const lowerCaseRoom = room.toLowerCase();

  if (/s*\(.*?\)/.test(lowerCaseRoom)) {
    return room.replace(/\s*\(/, '(s) (');
  }

  if (/room$/.test(lowerCaseRoom)) {
    return room.replace('room', 'room(s)');
  }

  if (lowerCaseRoom.slice(-1) === 's') {
    return room;
  }

  return `${room}(s)`;
};
